var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dollar-input"},[_c('input',{ref:"input",attrs:{"type":"text","required":""},domProps:{"value":_vm.realValue},on:{"input":_vm.handleInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }